//React
import * as React from 'react';

//MUI
import { Button } from '@mui/material';

function fRenderBanner(cMake)
{
    if(cMake.sBanner)
    {
        return <h1 className="center">{cMake.sBanner}</h1>;
    }
    else
    {
        return "";
    }
}

function TabLinkWidget({sSystemName, cMake, pSetCurrentTab})
{
    let systemConfig = require('../config/' + sSystemName + '.json');
    let systemCSS = require('../config/' + sSystemName + '.css');

    return (
        <div id={"widget_tab_link_" + cMake.sName}>
            {fRenderBanner(cMake)}
            <p className="center">{cMake.sText}<Button variant="contained" onClick={() => {pSetCurrentTab(cMake.sTabIndex)}}>{cMake.sTabName}</Button></p>
        </div>
    );
}

export default TabLinkWidget